import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User, UserDto, ProfileValue, PasswordValue } from '../models';
import { ProfileValueDto } from '../models/profile.value.dto';
import { PasswordValueDto } from '../models/password.value.dto';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getProfile(): Observable<User> {
        return this.httpClient.get<UserDto>('users/me').pipe(map((dto) => new User(dto)));
    }

    updateProfile(value: ProfileValue): Observable<User> {
        const dto = new ProfileValueDto(value);

        return this.httpClient.patch<UserDto>('profile', dto).pipe(map((response) => new User(response)));
    }

    changePassword(value: PasswordValue): Observable<void> {
        const dto = new PasswordValueDto(value);

        return this.httpClient.put<void>('users/me/password', dto);
    }
}
